import React from "react";
import styled from "styled-components";

const CheckboxContainer = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: flex-start;
  flex-direction: ${(props) => (props.reversed ? "row-reverse" : "row")};
  padding-left: 5px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin-right: 5px;

  background-color: ${(props) => (props.checked ? props.activeColor || "#8066FF" : "#FFFFFF")};
  border: 1px solid ${(props) => (props.checked ? props.activeColor || "#8066FF" : "#D6D5DD")};
  border-radius: 2px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
  &:hover {
    border: 1px solid #8066ff;
  }
`;

const Label = styled.div`
  color: ${(props) => (props.checked ? props.activeColor || "#8066FF" : "#5F5C70")};
  font-family: Public Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  margin-right: 5px;
`;

const Checkbox = ({ className, checked, ...props }) => {
  return (
    <CheckboxContainer className={className} reversed={props.reversed}>
      <StyledCheckbox checked={checked} {...props}>
        <HiddenCheckbox checked={checked} {...props} />
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
      <Label checked={checked} activeColor={props.activeColor}>
        {" "}
        {props.text}{" "}
      </Label>
    </CheckboxContainer>
  );
};

export default Checkbox;
